import { useIntl } from "react-intl";
import { WmButton } from "@watermarkinsights/ripple-react";
import { DraftPanelHeader } from "../draft-message/DraftPanelHeader";
import { buildSvgIconHref } from "../ai-chat-message-utils";

interface ChatHeaderProps {
  view: "chat" | "draft";
  isDraftResultView: boolean;
  onClose: () => void;
  onBackToConversation: () => void;
  onBackToSelection: () => void;
  onClearConversation: () => void;
  onOpenDraftPanel: () => void;
  isAiEnabled: boolean;
}

export const ChatHeader = ({
  view,
  isDraftResultView,
  onClose,
  onBackToConversation,
  onBackToSelection,
  onClearConversation,
  onOpenDraftPanel,
  isAiEnabled,
}: ChatHeaderProps) => {
  const intl = useIntl();

  if (view === "draft") {
    return (
      <DraftPanelHeader
        isDraftResultView={isDraftResultView}
        onBackToConversation={onBackToConversation}
        onBackToSelection={onBackToSelection}
        onClose={onClose}
      />
    );
  }

  return (
    <>
      <h2 className="tcw-header-title">
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          aria-hidden="true"
          className="tcw-header-title__icon"
        >
          <path
            d="M18 0L16.74 2.75L14 4L16.74 5.26L18 8L19.25 5.26L22 4L19.25 2.75M8 3L5.5 8.5L0 11L5.5 13.5L8 19L10.5 13.5L16 11L10.5 8.5M18 14L16.74 16.74L14 18L16.74 19.25L18 22L19.25 19.25L22 18L19.25 16.74"
            fill="currentColor"
          />
        </svg>
        {intl.formatMessage({ id: "app.toolboxChat.title" })}
      </h2>
      <div className="tcw-header-actions">
        <WmButton
          button-type="navigational"
          icon="#reset"
          className="tcw-header-btn"
          tooltip={intl.formatMessage({
            id: "app.toolboxChat.action.clearConversation",
          })}
          onClick={onClearConversation}
        />
        {isAiEnabled && (
          <WmButton
            button-type="navigational"
            icon={buildSvgIconHref("comment")}
            className="tcw-header-btn"
            tooltip={intl.formatMessage({
              id: "app.toolboxChat.action.openDraftConversation",
            })}
            onClick={() => isAiEnabled && onOpenDraftPanel()}
          />
        )}
        <WmButton
          button-type="navigational"
          icon="#close"
          className="tcw-header-btn"
          tooltip={intl.formatMessage({ id: "app.toolboxChat.action.close" })}
          onClick={onClose}
        />
      </div>
    </>
  );
};
